// extracted by mini-css-extract-plugin
export default {"row":"kdUWLo6gD2I4Y_zzj9er","item":"hw8B7d6XaF7C7pd3L0nL","title":"jkzefkeNOk7Sdcv961mT"};